import { ProfileModule } from '@/components/utilities/content-modules/profile-module-list/profile-module-list';

const getSectionModules = (
  items: Content.Components['ProfilePageItemDto'][],
) => {
  return items.map(item => item.contentModule as ProfileModule);
};

export const hasProfileNoLoyaltyWall = (
  section: Content.Components['ProfilePageSectionDto'],
) => {
  const sectionModules = getSectionModules(section.items);

  return sectionModules.some(
    module => module.$type === 'ProfileNoLoyaltyWallHeadlessModuleDto',
  );
};

export const hasProfileUserInformation = (
  section: Content.Components['ProfilePageSectionDto'],
) => {
  const sectionModules = getSectionModules(section.items);

  return sectionModules.some(
    module => module.$type === 'ProfileUserInformationHeadlessModuleDto',
  );
};
